export default "__VITE_ASSET__553be5fc__"